export default __webpack_public_path__ + "assets/cytolab-component.d1932566.svg";